import { render } from "./DependentsView.vue?vue&type=template&id=2594cbd0&scoped=true&ts=true"
import script from "./DependentsView.vue?vue&type=script&lang=ts"
export * from "./DependentsView.vue?vue&type=script&lang=ts"

import "./DependentsView.vue?vue&type=style&index=0&id=2594cbd0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2594cbd0"]])

export default __exports__